import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-custom-domain-fields',
  templateUrl: './custom-domain.component.html',
  styleUrls: ['./custom-domain.component.scss'],
  standalone: false,
})
export class CustomDomainComponent {
  public domainInput: string;
  public buddyDomainSelected = false;
  public buddyDomain: string;
  @Output() domains: EventEmitter<string[]> = new EventEmitter<string[]>();
  protected domain: string;
  protected domainTimeoutId = -1;
  private readonly wwwPrefix = 'www.';
  private readonly domainPattern = /^(([a-z0-9]|([a-z0-9][a-z0-9_-]*[a-z0-9]))\.)+[a-z0-9]{2,}$/i;

  public emitDomain(): void {
    if (this.domainTimeoutId !== -1) {
      window.clearTimeout(this.domainTimeoutId);
      this.domainTimeoutId = -1;
    }
    this.updateDomains();
    this.domainTimeoutId = window.setTimeout(() => this.domains.emit(this.getDomains()), 200);
  }

  public emitBuddyDomainFlag(): void {
    this.domains.emit(this.getDomains());
  }

  protected getDomains(): string[] {
    if (this.domain === '') {
      return [];
    }

    if (this.buddyDomainSelected && this.buddyDomain !== '') {
      return [this.domain, this.buddyDomain];
    } else {
      return [this.domain];
    }
  }

  protected updateDomains(): void {
    const domain = this.domainInput.trim();
    const nakedDomain = domain.startsWith(this.wwwPrefix) ? domain.slice(this.wwwPrefix.length) : domain;
    this.domain = domain;
    if (this.domainPattern.test(nakedDomain)) {
      this.buddyDomain = domain === nakedDomain ? this.wwwPrefix + domain : nakedDomain;
    } else {
      this.buddyDomain = '';
    }
  }
}
